import { Button, ButtonText } from '@/components/ui/button'
import { Center } from '@/components/ui/center'
import { Text } from '@/components/ui/text'
import { VStack } from '@/components/ui/vstack'
import { redirectAutoLogout, removeAuthToken } from '@/lib/api/authToken'
import usePlatformColor from '@/lib/hooks/usePlatformColor'
import { resetCurrentUser } from '@/redux/slices/currentUserSlice'
import { logoutThunk } from '@/redux/slices/sessionSlice'
import { useAppDispatch } from '@/redux/store'
import { useRouter } from 'expo-router'
import { LockIcon } from 'lucide-react-native'
import { Platform, View } from 'react-native'

export default function AccountDisabled() {
  const router = useRouter()
  const dispatch = useAppDispatch()
  const [systemRed, secondaryLabel] = usePlatformColor('systemRed', 'secondaryLabel')

  const handleLogout = () => {
    dispatch(resetCurrentUser())
    if (Platform.OS === 'web') {
      removeAuthToken()
      redirectAutoLogout()
      return
    }
    dispatch(logoutThunk())
    router.dismissAll()
    router.replace('/login')
  }

  return (
    <Center className="flex-1 px-10">
      <VStack space="md" className="items-center">
        <View className="w-20 h-20 rounded-full bg-red-100 dark:bg-red-900/30 items-center justify-center mb-2">
          <LockIcon size={40} color={systemRed as string} />
        </View>
        <Text size="xl" className="font-semibold">
          你的账户已被冻结
        </Text>
        <Text size="md" style={{ color: secondaryLabel }} className="text-center">
          封停原因已发送至注册邮箱，请查收
        </Text>
      </VStack>
      <Button size="lg" variant="outline" className="w-full max-w-sm mt-10" onPress={handleLogout}>
        <ButtonText>退出登录</ButtonText>
      </Button>
    </Center>
  )
}
